import $ from 'jquery'

export function onDarSettingsChanged(darSettings) {
    $(document).trigger('darSettings_changed', [darSettings])
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/syncCallbacks.js